<template>
  <span class="citytag" :class="{selected: isSelected}" @click="selectNode">{{ city.name }}</span>
</template>
<style>
.citytag {
    padding: 3px 25px;
    border-radius: 50px;
    border: 1px solid #eaeff5;
    font-size: 11px;
    display: inline-block;
    text-transform: uppercase;
    text-overflow:ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-size: 14px;
}
.citytag:hover {
  color: #fff;
  background-color: #d81c00;
  border: 1px solid #d81c00;
}
.citytag.selected {
  color: #fff;
  background-color: #d81c00;
  border: 1px solid #d81c00;
}
</style>
<script>
export default {
  name: 'CityTag',
  props: ['city', 'all'],
  computed: {
    isSelected: function() {
      for (let i = 0; i < this.all.length; i ++) {
        if (this.all[i].id == this.city.id) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    selectNode: function() {
      this.$emit('selected-city', this.city)
    }
  }
}
</script>